
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wekan-wiki-7-caddy-webserver-config.json") })
        }
      }, "path---wekan-wiki-7-caddy-webserver-config");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---wekan-wiki-7-caddy-webserver-config!./.cache/json/wekan-wiki-7-caddy-webserver-config.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---wekan-wiki-7-caddy-webserver-config!./.cache/json/wekan-wiki-7-caddy-webserver-config.json
// module chunks = 154